import axios from 'axios';
 import router from "./router/index"
 
// 创建axios实例

//axios.defaults.timeout = 5000



let loadinginstace
axios.interceptors.request.use(config => {
    console.log(sessionStorage.getItem("token"),"token");
   // element ui Loading方法
   //loadinginstace = Loading.service({ fullscreen: true })
   
   if(sessionStorage.getItem("token")==''){
    router.replace({
      path: '/',
      query: {redirect: router.currentRoute.fullPath}
    })
   }
  
   return config
}, error => {
   //loadinginstace.close();
   
　　return Promise.reject(error)
})

// http响应拦截器
axios.interceptors.response.use(data => {
   // 响应成功关闭loading
   //loadinginstace.close();  
   console.log("data",data) ;
　　const code = data.data.stateCode;
console.log("code",code) ;
　　if(code == 401) {
    
    console.log("code1",code) ;
      router.replace({
        path: '/',
        query: {redirect: router.currentRoute.fullPath}
      })
　　}
    
    return data;
   
}, error => {
  // loadinginstace.close();
　  console.log(error);
   return error;
　
})

export default axios;



// WEBPACK FOOTER //
// ./src/http.js